import React from 'react';
import { Locales } from '@ratehub/base-ui';
import { PATHS } from '@ratehub/web-components';

import BLOCK_MAP from '../definitions/TemplateBlogHomeBlockMap';
import createBlogHomeStaticProps from '../functions/createBlogHomeStaticProps';
import withFrenchLocale from '../functions/withFrenchLocale';
import BlogHomePage from '../components/BlogHomePage';
import WordpressPage from '../components/WordpressPage';


/**
 * blogGeneric: Handles Blog Home & Blog Authors (plural – singlular is handled
 * by blogAuthor)
 */

const { getStaticPaths, getStaticProps } = createBlogHomeStaticProps({
    locale: Locales.FRENCH,
    fileName: 'blogGenericFR',
    path: [ PATHS.BLOG_FR ],
    blockMap: BLOCK_MAP,
});

// Stripped down version of createStaticWordpressPage
const page = function Page({ isAuthorPage, ...otherProps }) {
    return (
        <Choose>
            <When condition={isAuthorPage}>
                <WordpressPage
                    blockMap={BLOCK_MAP}
                    {...otherProps}
                />
            </When>
            <Otherwise>
                <BlogHomePage
                    blockMap={BLOCK_MAP}
                    {...otherProps}
                />
            </Otherwise>
        </Choose>
    );
};

export default withFrenchLocale(page);
export { getStaticPaths, getStaticProps };
